var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSectionArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 20,
    viewBox: "0 0 138 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9939 12.8618C76.2931 22.1775 61.8886 22.241 54.2703 12.8577C47.6661 4.7235 37.7468 2.67968e-06 27.2692 1.7637e-06L2.71011e-06 -6.20251e-07L138 1.14441e-05L111.197 9.10089e-06C100.702 8.18341e-06 90.6805 4.77293 83.9939 12.8618Z",
    fill: "#FEC901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3449 12.9809C69.1518 13.1649 68.8482 13.1649 68.6551 12.9809L62.4944 7.11202C62.1676 6.80072 62.388 6.25 62.8393 6.25L75.1607 6.25C75.612 6.25 75.8324 6.80073 75.5056 7.11203L69.3449 12.9809Z",
    fill: "white",
    stroke: "#FFFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionArrow);
export default __webpack_public_path__ + "static/media/sectionArrow.bad600cdb0f978c72a92844c6ba6861d.svg";
export { ForwardRef as ReactComponent };